import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Playbooks",
  published_at: "2026-01-26",
  summary: "Save and reuse your best AI prompts so you never have to write the same instruction twice.",
  tags: ["AI"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "You can now save your most-used AI instructions as Playbooks. Whether it's a specific way you like proposals reviewed, a format for executive summaries, or a checklist you run on every RFP, save it once and reuse it with a single click. Playbooks live in your sidebar and can be shared across your team, so everyone benefits from your best practices."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "2b0b665f-64a0-5c47-ad0c-4a0db46e291f"
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Pursuits (6)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Tasks now include a calendar view for tracking deadlines visually"
        }), "\n", _jsx(_components.li, {
          children: "Tags can now be applied to individual pursuit files"
        }), "\n", _jsx(_components.li, {
          children: "Amendment diffs highlight what changed between solicitation versions"
        }), "\n", _jsx(_components.li, {
          children: "Color-coded requirements for easier scanning"
        }), "\n", _jsx(_components.li, {
          children: "Fixed pursuit stages not updating in certain workflows"
        }), "\n", _jsx(_components.li, {
          children: "Export pursuit notes to Word documents"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Documents (4)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "New filters for searching files across your document library"
        }), "\n", _jsx(_components.li, {
          children: "Copy files directly into your document library from pursuits"
        }), "\n", _jsx(_components.li, {
          children: "Fixed file read errors on some uploaded documents"
        }), "\n", _jsx(_components.li, {
          children: "Fixed tables not rendering correctly in pursuit notes"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "AI (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "AI reports now include relevant images from your documents"
        }), "\n", _jsx(_components.li, {
          children: "Smarter image handling when chatting with the AI assistant"
        }), "\n", _jsx(_components.li, {
          children: "Fixed AI report exports occasionally failing"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "UX (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Drag-and-drop column reordering in tables"
        }), "\n", _jsx(_components.li, {
          children: "Fixed an error when reviewing proposals with certain formatting"
        }), "\n", _jsx(_components.li, {
          children: "Fixed editor comments sometimes disappearing after refresh"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
